
(function () {
  if (window.__VVE_QTYBAR_INIT__) return;
  window.__VVE_QTYBAR_INIT__ = true;

  function clamp(v, min, max){ return Math.max(min, Math.min(max, v)); }

  function getTier(bar, n){
    return {
      qty: parseInt(bar.dataset['tier'+n+'Qty'] || '0', 10),
      pct: parseInt(bar.dataset['tier'+n+'Pct'] || '0', 10)
    };
  }

  function escapeHTML(value){
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function renderStatePart(element, text, emphasis){
    if (!element) return;
    const safeText = escapeHTML(text);
    const safeEmphasis = escapeHTML(emphasis);
    element.innerHTML = safeEmphasis && safeText.includes(safeEmphasis)
      ? safeText.replace(safeEmphasis, '<span class="qtybar__state-emphasis">' + safeEmphasis + '</span>')
      : safeText;
  }

  function renderOwnerProgress(bar, itemCount){
    const displayCount = clamp(itemCount, 0, 5);
    const fillEl = bar.querySelector('[data-qtybar-fill]');
    const stateEl = bar.querySelector('[data-qtybar-state]');
    const primaryEl = bar.querySelector('[data-qtybar-state-primary]');
    const separatorEl = bar.querySelector('[data-qtybar-state-separator]');
    const secondaryEl = bar.querySelector('[data-qtybar-state-secondary]');
    const progressEl = bar.querySelector('.qtybar__progress[role="progressbar"]');

    const fillPercent = (displayCount / 5) * 100;
    if (fillEl) fillEl.style.setProperty('--qtybar-fill-percent', fillPercent + '%');
    if (fillEl) {
      fillEl.style.width = displayCount > 0 && displayCount < 5
        ? 'calc(' + fillPercent + '% + 0.6rem)'
        : fillPercent + '%';
    }

    bar.querySelectorAll('[data-qtybar-point]').forEach(function(point){
      const position = parseInt(point.dataset.position || '0', 10);
      point.classList.toggle('is-reached', itemCount > 0 && position <= displayCount);
    });

    const stateIndex = Math.min(displayCount, 5);
    const text = bar.getAttribute('data-state-' + stateIndex) || '';
    const primary = bar.getAttribute('data-state-' + stateIndex + '-primary') || text;
    const secondary = bar.getAttribute('data-state-' + stateIndex + '-secondary') || '';
    const emphasis = bar.getAttribute('data-state-' + stateIndex + '-emphasis') || '';

    renderStatePart(
      bar.querySelector('.vc-cart-incentive'),
      (bar.getAttribute('data-state-0-primary') || '').replace(/^Start\b/, 'Continue'),
      bar.getAttribute('data-state-0-emphasis') || ''
    );

    if (stateEl) {
      renderStatePart(primaryEl, primary, emphasis);
      renderStatePart(secondaryEl, secondary, '');
      if (separatorEl) separatorEl.hidden = !secondary;
      if (secondaryEl) secondaryEl.hidden = !secondary;
      stateEl.dataset.hasSecondary = secondary ? 'true' : 'false';
      stateEl.setAttribute('aria-label', [primary, secondary].filter(Boolean).join('. '));
    }

    bar.dataset.ownerState = String(stateIndex);
    if (progressEl) progressEl.setAttribute('aria-valuenow', String(displayCount));
  }

  function styleCircle(bar, msEl, reached){
    if (!msEl) return;
    const circle = msEl.querySelector('.qtybar__milestone-circle');
    if (!circle) return;

    if (reached) {
      const reachedColor = bar.closest('#CartDrawer') ? '#0057ff' : '#000';
      circle.style.setProperty('background-color', reachedColor, 'important');
      circle.style.setProperty('border-color', reachedColor, 'important');
      circle.style.setProperty('color', '#fff', 'important');
    } else {
      // UNREACHED = grey fill + grey stroke + black number
      circle.style.setProperty('background-color', '#d9d9d9', 'important');
      circle.style.setProperty('border-color', '#d9d9d9', 'important');
      circle.style.setProperty('color', '#000', 'important');
    }
  }

  // Apply once after section rendering.
  function forceMilestoneStyles(bar, r1, r2, r3){
    const ms1 = bar.querySelector('.qtybar__milestone[data-ms="1"]');
    const ms2 = bar.querySelector('.qtybar__milestone[data-ms="2"]');
    const ms3 = bar.querySelector('.qtybar__milestone[data-ms="3"]');

    const apply = () => {
      styleCircle(bar, ms1, r1);
      styleCircle(bar, ms2, r2);
      styleCircle(bar, ms3, r3);
    };

    apply();

  }

  function renderBar(bar, itemCount){
    itemCount = parseInt(itemCount || '0', 10);

    if (bar.dataset.ownerProgress === 'true') {
      renderOwnerProgress(bar, itemCount);
      return;
    }

    const t1 = getTier(bar, 1);
    const t2 = getTier(bar, 2);
    const t3 = getTier(bar, 3);

    const noun   = (bar.dataset.noun || 'items');
    const preTpl = bar.dataset.preTpl || '';
    const gainedTpl = bar.dataset.gainedTpl || '';
    const nextTpl = bar.dataset.nextTpl || '';
    const maxTpl  = bar.dataset.maxTpl || '';

    const topEl = bar.querySelector('[data-qtybar-top]');
    const bottomEl = bar.querySelector('[data-qtybar-bottom]');
    const fillEl = bar.querySelector('[data-qtybar-fill]');
    const thumbEl = bar.querySelector('[data-qtybar-thumb]');
    const thumbTextEl = bar.querySelector('[data-qtybar-thumb-text]');

    const ms1 = bar.querySelector('.qtybar__milestone[data-ms="1"]');
    const ms2 = bar.querySelector('.qtybar__milestone[data-ms="2"]');
    const ms3 = bar.querySelector('.qtybar__milestone[data-ms="3"]');
    const msCircles = bar.querySelectorAll('[data-ms-circle]');

    // milestone numbers
    if (msCircles && msCircles.length === 3) {
      msCircles[0].textContent = t1.qty || '';
      msCircles[1].textContent = t2.qty || '';
      msCircles[2].textContent = t3.qty || '';
    }

    // positions
    const maxQty = Math.max(t1.qty, t2.qty, t3.qty, 1);
    const pctPos = (q) => clamp((q / maxQty) * 100, 0, 100);

    if (ms1) ms1.style.left = pctPos(t1.qty) + '%';
    if (ms2) ms2.style.left = pctPos(t2.qty) + '%';
    if (ms3) ms3.style.left = pctPos(t3.qty) + '%';

    // progress (cap the visual count at max tier)
    const displayCount = Math.min(itemCount, maxQty);
    const progress = clamp((displayCount / maxQty) * 100, 0, 100);
    if (fillEl) fillEl.style.width = progress + '%';
    if (thumbEl) thumbEl.style.left = progress + '%';

    // Hide thumb if it overlaps a milestone (same qty)
    if (thumbEl) {
      const t1q = parseInt(bar.dataset.tier1Qty || '0', 10);
      const t2q = parseInt(bar.dataset.tier2Qty || '0', 10);
      const t3q = parseInt(bar.dataset.tier3Qty || '0', 10);

      const overlaps =
        (t1q && displayCount === t1q) ||
        (t2q && displayCount === t2q) ||
        (t3q && displayCount === t3q);

      thumbEl.classList.toggle('is-hidden', overlaps);
    }

    if (thumbTextEl) thumbTextEl.textContent = displayCount;

    // reached flags (THIS is the only truth)
    const r1 = (t1.qty > 0) && (itemCount >= t1.qty);
    const r2 = (t2.qty > 0) && (itemCount >= t2.qty);
    const r3 = (t3.qty > 0) && (itemCount >= t3.qty);

    // Keep classes too (optional, but harmless)
    if (ms1) ms1.classList.toggle('is-reached', r1);
    if (ms2) ms2.classList.toggle('is-reached', r2);
    if (ms3) ms3.classList.toggle('is-reached', r3);

    // FORCE the visual state (fixes “tier reached but not filled”)
    forceMilestoneStyles(bar, r1, r2, r3);

    // copy logic
    let currentPct = 0;
    let nextQty = null;
    let nextPctVal = null;

    if (r3) {
      currentPct = t3.pct;
    } else if (r2) {
      currentPct = t2.pct;
      nextQty = t3.qty; nextPctVal = t3.pct;
    } else if (r1) {
      currentPct = t1.pct;
      nextQty = t2.qty; nextPctVal = t2.pct;
    } else {
      nextQty = t1.qty; nextPctVal = t1.pct;
    }

    /* TOP should show: Before tier text + Gained text */
    if (topEl) {
      if (currentPct > 0) {
        // gained text
        topEl.innerHTML = gainedTpl.replaceAll('{percent}', String(currentPct));
      } else {
        // before tier text
        const remaining = Math.max(t1.qty - itemCount, 0);
        topEl.innerHTML = preTpl
          .replaceAll('{remaining}', String(remaining))
          .replaceAll('{noun}', noun)
          .replaceAll('{percent}', String(t1.pct));
      }
    }

    /* BOTTOM should show: Next tier text + Max tier text */
    if (bottomEl) {
      if (nextQty != null) {
        // next tier text
        const remaining = Math.max(nextQty - itemCount, 0);
        bottomEl.innerHTML = nextTpl
          .replaceAll('{remaining}', String(remaining))
          .replaceAll('{noun}', noun)
          .replaceAll('{next_percent}', String(nextPctVal));
      } else {
        // max tier text
        bottomEl.innerHTML = maxTpl.replaceAll('{percent}', String(currentPct));
      }
    }

    const progressEl = bar.querySelector('.qtybar__progress[role="progressbar"]');
    if (progressEl) progressEl.setAttribute('aria-valuenow', String(Math.round(progress)));
  }

  function updateAllBarsFromCart(cart){


    document.querySelectorAll('.cart-shipping[data-qtybar]').forEach(function(bar){
      const dsCount = parseInt(bar.dataset.itemCount || '0', 10) || 0;
      const barCount = dsCount;

      // keep dataset in sync so the bar doesn't get "stuck"
      bar.dataset.itemCount = String(barCount);

      const isEmpty = (barCount === 0);
      const showInEmptyDrawer = bar.dataset.showInEmptyDrawer === 'true';
      const showInEmptyCart = bar.dataset.showInEmptyCart === 'true';

      if (isEmpty) {
        const inDrawer = !!bar.closest('#CartDrawer');
        const allow = inDrawer ? showInEmptyDrawer : showInEmptyCart;
        bar.style.display = allow ? '' : 'none';
      } else {
        bar.style.display = '';
      }

      renderBar(bar, barCount);
    });
  }



  document.addEventListener('cart:rendered', updateAllBarsFromCart);
  document.addEventListener('shopify:section:load', updateAllBarsFromCart);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAllBarsFromCart, { once: true });
  else updateAllBarsFromCart();
})();

